import { createSlice } from '@reduxjs/toolkit';
import { defaultCurrencyKeysListWithIds } from '../utils/requests/currenciesList';
import localStorageKeys from '../utils/localStorageKeys';
;
const storedCurrencyKeysListWithIds = localStorage.getItem(localStorageKeys.currenciesOrder);
const currencyKeysListWithIds = storedCurrencyKeysListWithIds
    ? JSON.parse(storedCurrencyKeysListWithIds)
    : defaultCurrencyKeysListWithIds;
const initialState = {
    periodicExchangeRatesData: {
        latest: null,
        monthAgo: null,
        halfYearAgo: null,
    },
    draggingRowsEnabled: false,
    currenciesOrderedList: currencyKeysListWithIds,
};
const mainSlice = createSlice({
    name: 'main',
    initialState,
    reducers: {
        // ####################################################################################
        setDraggingRowsEnabled: (state, { payload }) => {
            state.draggingRowsEnabled = payload;
        },
        setPeriodicExchangeRatesData: (state, { payload }) => {
            state.periodicExchangeRatesData = payload;
        },
        setCurrenciesOrderedList: (state, { payload }) => {
            state.currenciesOrderedList = payload;
        },
        // ####################################################################################
    },
});
export const { setDraggingRowsEnabled, setPeriodicExchangeRatesData, setCurrenciesOrderedList, } = mainSlice.actions;
export default mainSlice.reducer;
